import {
    debug
} from '@kkmh/utils'

export const doTrackPopupShow = (opt = {}) => {
    if (!checkIdentify()) {
        // 埋点未初始化,不进行上报
        return;
    }
    const activity_name = 'PopupShow';
    debug(activity_name, opt);
    kksa.track(activity_name, opt);

}

export const doTrackPopupItemImp = (opt = {}) => {
    if (!checkIdentify()) {
        // 埋点未初始化,不进行上报
        return;
    }
    const activity_name = 'PopupItemImp';
    debug(activity_name, opt);
    kksa.track(activity_name, opt);
}

export const doTrackPopupItemClk = (opt = {}) => {
    if (!checkIdentify()) {
        // 埋点未初始化,不进行上报
        return;
    }
    let activity_name = 'PopupItemClk';
    debug(activity_name, opt);
    kksa.track(activity_name, opt);
}
export const doTrack = (name, opt)=>{
    if (!checkIdentify()) {
        // 埋点未初始化,不进行上报
        return;
    }
    debug(name, opt);
    kksa.track(name, opt);
}

function checkIdentify() {
    if (typeof kksa != "undefined" && kksa.is_identified) {
        return true;
    }
    return false;
}



// WEBPACK FOOTER //
// ./node_modules/@kkmh/pays/src/components/kkbhalfscreen/js/track.js